import React, { PureComponent } from "react";
import autoBind from "react-autobind";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import _ from "lodash";
import ScrollIntoViewIfNeeded from "react-scroll-into-view-if-needed";
import Modal from "react-responsive-modal";
import { Button } from "react-bootstrap";

//import LinearGradient from "react-native-linear-gradient";
import * as playerActions from "../../actions/playerActions";
import { getFilteredCurrentActivity, getTopLevel } from "../../utils/Search";
import { getRealName } from "../../utils/utils";

const removeMd = require("remove-markdown");

class BreadcrumbDialog extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			expanded: {},
			searchFilter: {},
			query: "",
			showStructureModal: false,
			structureMode: null,
			levelExpanded: {},
			showInvisible: false
		};
		this.searchField = React.createRef();
		autoBind(this);
	}

	handleHideView() {
		this.props.dispatch(playerActions.setExpandedBreadcrumbView, null);
	}


	handleToggleExpand(guid, _expanded = false) {
		const { expanded } = this.state;
		expanded[guid] = !expanded.hasOwnProperty(guid) ? !_expanded : !expanded[guid];
		// console.log("Setting expanded state", expanded);
		this.setState({
			expanded: _.cloneDeep(expanded)
		});
	}



	handleRenderActivityTree(entity, selectionHierarchy = { item: null, section: null, list: null }, dialogTheme) {
		if (!entity || (entity.hasOwnProperty("excludeFromNavigation") && entity.excludeFromNavigation) || (!entity.visible && !this.state.showInvisible && (entity.type !== "activity" && entity.type !== "checklist"))) {
			return null;
		}

		// console.log("Handle render activity tree entity", entity);
		let result = [];
		const { type, completionState } = entity;

		const colorNotStarted = "red";
		const colorInProgress = "#F9A200";
		const colorCompleted = "lightgreen";

		let completionIcon = <FontAwesomeIcon icon="circle" style={{ color: colorNotStarted, marginRight: 5 }} />;
		if (completionState === "i") {
			completionIcon = <FontAwesomeIcon icon="circle" style={{ color: colorInProgress, marginRight: 5 }} />;
		} else if (completionState === "c") {
			completionIcon = <FontAwesomeIcon icon="check-circle" style={{ color: colorCompleted, marginRight: 5 }} />;
		}

		switch (type) {
			case "checklist":
			case "activity": {
				result.push(
					<div style={{overflowX:"hidden",overflowY:"auto"}}>
						{
							entity.children.map(list => {
								return this.handleRenderActivityTree(list, selectionHierarchy, dialogTheme);
							})
						}
					</div>
				);
				break;
			}
			case "item": {
				const { item: selectedItem } = selectionHierarchy;
				const item = entity;
				const { guid, visible, checked, enabled } = item;
				const title = item.navTitle ? item.navTitle : removeMd(item.label1);
				const selected = guid === selectedItem.guid;
				const _textStyles = selected ? dialogTheme.itemRowSelectedText : dialogTheme.itemRowText;
				if (checked) {
					completionIcon = <FontAwesomeIcon icon="check-circle" style={{ color: colorCompleted, marginRight: 5 }} />;
				}

				const additionalStatusIndicators = [completionIcon];
				if (!visible) {
					additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-items-${guid}-not-visible`} style={_.assign({},dialogTheme.functionButtonText, { marginRight: 5 })} icon="eye-slash" />);
				}
				if (!enabled) {
					additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-items-${guid}-mandatory-lock`} style={_.assign({},dialogTheme.functionButtonText, { marginRight: 5 })} icon="lock-alt" />);
				}
				if (!selected) {
					if (visible && enabled) {
						result.push(<div style={dialogTheme.itemRow} key={`tree-items-${guid}`} onClick={() => { this.props.dispatch(playerActions.setSelectedItemByGuid, guid, true); this.handleHideView(); }}>
							{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
						</div>);
					} else {
						result.push(<div style={_.assign({},dialogTheme.itemRow, dialogTheme.itemRowNotVisible)} key={`tree-items-${guid}`}>
							{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
						</div>);
					}
				} else {
					result.push(<ScrollIntoViewIfNeeded options={{
						behavior: "smooth",
						block: "center",
						inline: "center"
					}} key={`tree-items-${guid}-${this.state.expandAll}`} style={_.assign({},dialogTheme.itemRow, dialogTheme.itemRowSelected)}>
						{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
					</ScrollIntoViewIfNeeded>);
				}
				break;
			}
			case "section": {
				const { section: selectedSection } = selectionHierarchy;
				const section = entity;
				const { guid, enabled, visible, insertedByNormalization } = section;

				if (insertedByNormalization) {
					result.push(
						<>
							{section.children.map(section => {
								return this.handleRenderActivityTree(section, selectionHierarchy, dialogTheme);
							})}
						</>
					);
					return result;
				}

					const title = section.navTitle ? section.navTitle : section.name;

					const selected = guid === selectedSection.guid;
					const _textStyles = selected ? dialogTheme.sectionRowSelectedText : dialogTheme.sectionRowText;
					const _styles = _.assign({}, dialogTheme.sectionRow, selected ? dialogTheme.sectionRowSelected : {});
					const expanded = this.isExpanded(section, selectionHierarchy);
					const hasChildren = section.children && section.children.length !== 0;

				const expandCollapse = <Button bsSize="small" disabled={!hasChildren} style={dialogTheme.expandCollapseButton} onClick={(e) => { this.handleToggleExpand(guid, expanded); e.stopPropagation(); }}><FontAwesomeIcon style={dialogTheme.functionButtonText} icon={expanded && hasChildren ? "minus" : "plus"} /></Button>;

					const additionalStatusIndicators = [expandCollapse, completionIcon];

					if (!visible) {
						additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-sections-${guid}-not-visible`} style={_.assign({}, dialogTheme.functionButtonText, { marginRight: 5 })} icon="eye-slash" />);
					}
					if (!enabled) {
						additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-sections-${guid}-mandatory-lock`} style={_.assign({}, dialogTheme.functionButtonText, { marginRight: 5 })} icon="lock-alt" />);
					}

					result.push(<div key={`tree-sections-${guid}`} style={_styles} onClick={() => { this.props.dispatch(playerActions.setSelectedItemByGuid, guid, true); this.handleHideView(); }}>
						{additionalStatusIndicators}<div style={_textStyles} ellipsizeMode="tail" numberOfLines={1}>{title}</div>
					</div>);


					if (expanded) {
						result.push(
							<div style={{ paddingLeft: 50 }}>
								{
									section.children.map(item => {
										return this.handleRenderActivityTree(item, selectionHierarchy, dialogTheme);
									})
								}
							</div>
						);
					}
				
				break;
			}
			case "list": {
				const { list: selectedList } = selectionHierarchy;
				const list = entity;
				const { guid, visible, enabled, insertedByNormalization } = list;
				if (insertedByNormalization) {
					result.push(
						<>
							{
								list.children.map(section => {
									return this.handleRenderActivityTree(section, selectionHierarchy, dialogTheme);
								})
							}
							</>
					);
					return result;
				}

				
					const title = list.navTitle ? list.navTitle : list.name;
					const selected = guid === selectedList.guid;
					const _textStyles = selected ? dialogTheme.listRowSelectedText : dialogTheme.listRowText;
					const _styles = _.assign({}, dialogTheme.listRow, guid === selectedList.guid ? dialogTheme.listRowSelected : {});
					const expanded = this.isExpanded(list, selectionHierarchy);
					const hasChildren = list.children && list.children.length !== 0;

					const expandCollapse = <Button bsSize="small" disabled={!hasChildren} style={dialogTheme.expandCollapseButton} onClick={(e) => { this.handleToggleExpand(guid, expanded); e.stopPropagation(); }}><FontAwesomeIcon style={dialogTheme.functionButtonText} icon={expanded && hasChildren ? "minus" : "plus"} /></Button>;

					const additionalStatusIndicators = [expandCollapse, completionIcon];

					if (!visible) {
						additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-lists-${guid}-not-visible`} style={_.assign({}, dialogTheme.functionButtonText, { marginRight: 5 })} icon="eye-slash" />);
					}
					if (!enabled) {
						additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-lists-${guid}-mandatory-lock`} style={_.assign({}, dialogTheme.functionButtonText, { marginRight: 5 })} icon="lock-alt" />);
					}


					result.push(<div key={`tree-lists-${guid}`} style={_styles} onClick={() => { this.props.dispatch(playerActions.setSelectedItemByGuid, guid, true); this.handleHideView(); }}>
						{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
					</div>);

					if (expanded) {
						result.push(
							<div style={{ paddingLeft: 15 }}>
								{
									list.children.map(section => {
										return this.handleRenderActivityTree(section, selectionHierarchy, dialogTheme);
									})
								}
							</div>
						);
					}
				
				break;
			}
			default: {
				if (type && type.startsWith("item")) {
					const { item: selectedItem } = selectionHierarchy;
					const item = entity;
					const { guid, visible, checked, enabled } = item;
					const title = item.navTitle ? item.navTitle : removeMd(item.label1);
					const selected = guid === selectedItem.guid;
					const _textStyles = selected ? dialogTheme.itemRowSelectedText : dialogTheme.itemRowText;
					if (checked) {
						completionIcon = <FontAwesomeIcon icon="check-circle-o" style={{ color: colorCompleted, marginRight: 5 }} />;
					}

					const additionalStatusIndicators = [completionIcon];
					if (!visible) {
						additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-items-${guid}-not-visible`} style={_.assign({},dialogTheme.functionButtonText, { marginRight: 5 })} icon="eye-slash" />);
					}
					if (!enabled) {
						additionalStatusIndicators.push(<FontAwesomeIcon key={`tree-items-${guid}-mandatory-lock`} style={_.assign({},dialogTheme.functionButtonText, { marginRight: 5 })} icon="lock-alt" />);
					}

					if (!selected) {
						if (visible && enabled) {
							result.push(<div style={dialogTheme.itemRow} key={`tree-items-${guid}`} onClick={() => { this.props.dispatch(playerActions.setSelectedItemByGuid, guid, true); this.handleHideView(); }}>
								{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
							</div>);
						} else {

							result.push(<div style={_.assign({},dialogTheme.itemRow, dialogTheme.itemRowNotVisible)} key={`tree-items-${guid}`}>
								{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
							</div>);
						}
					} else {
						result.push(<ScrollIntoViewIfNeeded options={{
							behavior: "smooth",
							block: "center",
							inline: "center"
						}} key={`tree-items-${guid}-${this.state.expandAll}`} style={_.assign({},dialogTheme.itemRow, dialogTheme.itemRowSelected)}>
							{additionalStatusIndicators}<div style={_textStyles}>{title}</div>
						</ScrollIntoViewIfNeeded>);
					}
				}
			}
		}

		return result;
	}

	isExpanded(entity, selectionHierarchy) {
		const { type, guid } = entity;
		const selectedEntity = selectionHierarchy[type];
		const { hasLevelExpansion, levelExpanded, expanded, expandAll } = this.state;
		const _levelExpanded = levelExpanded[type];


		return hasLevelExpansion ? (
			expanded[guid] === true || _levelExpanded
			) :
		(
			expanded[guid] === true ||
			(
				expanded[guid] !== false && (
					guid === selectedEntity.guid ||
					expandAll ||
					_levelExpanded
				)
			)
		);
	}

	handleToggleExpandAll() {
		const expandAll = !this.state.expandAll;
		if (expandAll) {
			this.handleExpandAll();
		} else {
			this.handleCollapseAll();
		}
	}

	handleExpandAll() {
		this.setState({
			expandAll: true,
			hasLevelExpansion:false,
			levelExpanded: {
				list: true,
				section: true
			},
			expanded: {}
		});
	}

	handleCollapseAll() {
		this.setState({
			expandAll: false,
			hasLevelExpansion: true,
			levelExpanded: {
				list: false,
				section: false
			},
			expanded: {}
		});
	}

	handleFilter(e) {
		const query = e.target.value;
		if (query.length > 3) {
			if (!this.state.expandAll) {
				this.handleExpandAll();
			}
		}
		this.setState({
			query
		});
	}

	handleRenderStructureButton(dialogTheme, topLevel="list") {
		let icon = "bars";
		let nextStructureView = topLevel === "list" ? "lists" : "sections";

		const { selectedStructureMode } = this.state;
		switch (selectedStructureMode) {
			case "lists": {
				icon = "list";
				nextStructureView = "sections";
				break;
			}
			case "sections": {
				icon = "list-alt";
				nextStructureView = "toc";
				break;
			}
			default: {
				console.warn("Unknown selected structure mode", selectedStructureMode);
			}
		}

		return (<div style={_.omit(dialogTheme.functionButtons, ["flex"])}>
			<div style={dialogTheme.functionButton} onClick={() => this.handleSwitchStructureMode(nextStructureView)}>
				<FontAwesomeIcon style={dialogTheme.functionButtonText} icon={icon} />
			</div>
			<div style={{ width: 1, height: 25, borderLeftWidth: 1, borderLeftColor: "lightgray" }} />
			<div style={dialogTheme.functionButton} onClick={this.handleShowOptions}>
				<FontAwesomeIcon style={dialogTheme.functionButtonText} icon="sort-down"/>
			</div>
		</div>);
	}

	handleShowOptions() {
		this.setState({
			showStructureModal: true
		});
	}

	handleSwitchStructureMode(mode) {
		let selectedStructureMode = mode;
		switch (mode) {
			case "toc": {
				this.handleExpandAll();
				break;
			}
			case "lists": {
				this.handleCollapseAll();
				break;
			}
			case "sections": {
				this.setState({
					expandAll: false,
					hasLevelExpansion:true,
					levelExpanded: {
						list: true,
						section: false
					},
					expanded: {}
				});
				break;
			}
			default: {
				console.warn("Unknown view mode", mode);
			}
		}
		this.setState({
			showStructureModal: false,
			selectedStructureMode
		});
	}

	handleHideStructureModeModal() {
		this.setState({
			showStructureModal: false
		});
	}

	handleToggleShowInvisible() {
		const showInvisible = !this.state.showInvisible;
		this.setState({
			showInvisible
		});
	}

	handleRenderStructureModeSelectItem(icon, title, description, structureMode, topLevel, dialogTheme) {
		const { selectedStructureMode } = this.state;
		let result = null;
		const contents = <>
			<div style={{ flex: 0, width: 50, justifyContent: "center", alignItems: "center", display:"flex", flexDirection:"column" }}>
				<FontAwesomeIcon icon={icon} style={{ color: "white", fontSize: 40 }} />
			</div>
			<div style={{ justifyContent: "center", alignItems: "flex-start", paddingLeft: 10, display: "flex", flexDirection: "column" }}>
				<div style={{ fontSize: 30, color: "white" }}>{title}</div>
				<div style={{ fontSize: 15, color: "white" }}>{description}</div>
			</div>
		</>;

		if (selectedStructureMode === structureMode) {
			result = <div style={_.assign({},dialogTheme.structureModeRow, dialogTheme.structureModeRowSelected)}>
				{contents}
			</div>;

		} else {
			result = <div style={dialogTheme.structureModeRow} onClick={() => { this.handleSwitchStructureMode(structureMode); }}>
				{contents}
			</div>;
		}

		return result;
	}

	handleRenderFilterInvisibleButton(dialogTheme) {

		const { showInvisible } = this.state;

		const icon = showInvisible ? "eye-slash" : "eye";

		return (
			<div style={_.assign({},dialogTheme.functionButtons, { flex: 0 })}>
				<div style={dialogTheme.functionButton} onClick={this.handleToggleShowInvisible}>					
					<FontAwesomeIcon style={dialogTheme.functionButtonText} icon={icon} />
				</div>
			</div>
		);
	}


	handleRenderView(view = this.props.expandedView) {
		let result = null;
		let itemStyle = {
			color: "white",
			whiteSpace: "noWrap",
			overflow: "hidden",
			textOverflow: "ellipsis"
		};
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const { breadcrumb: breadcrumbTheme } = theme;
		const { dialog: dialogTheme } = breadcrumbTheme;
		switch (view) {
			case "tree": {
				const selectionHierarchy = playerActions.getSelectionHierarchy();
				result = [];
				const filteredTree = getFilteredCurrentActivity(this.state.query);
				const topLevel = getTopLevel();
				result.push(<div key="breadcrumb-search-field" style={dialogTheme.treeFunctionBarWrapper}>
					<div style={{ flexDirection: "row", justifyContent: "flex-start", flex: 1, display:"flex" }}>
						{topLevel !== "item" && <div style={dialogTheme.functionButtons}>
							{this.handleRenderStructureButton(dialogTheme, topLevel)}
						</div>}
						<div style={_.assign({},dialogTheme.functionButtons, { paddingLeft: 5 })}>
							{this.handleRenderFilterInvisibleButton(dialogTheme)}
						</div>
					</div>
					<div style={{ position: "relative", flex: 1, display: "flex" }}>
						<input ref={this.searchField} style={dialogTheme.searchBox} onChange={this.handleFilter} value={this.state.query} />
						<FontAwesomeIcon icon="search" style={{ position: "absolute", left: 5, top: 5, fontSize: 20, color: "white", width: 20, height: 20 }} />
					</div>
				</div>);

				if (filteredTree && filteredTree.children && filteredTree.children.length > 0) {
					console.log("Render activity tree", filteredTree);
					result.push(this.handleRenderActivityTree(filteredTree, selectionHierarchy, dialogTheme));
				} else if (this.state.query && this.state.query.length > 2) {
					result.push(<div style={{ flex: 1, width: "100%", height: "100%", justifyContent: "center", alignItems: "center", display: "flex" }}>
						<div style={{ color: "white" }}>No results found for</div>
						<div style={{ fontSize: 20, color: "white" }}>"{this.state.query}"</div>
					</div>);
				}

				result.push(<Modal
					open={this.state.showStructureModal}
					onClose={this.handleHideStructureModeModal}
					showCloseIcon={false}
					styles={{
						modal: {
							padding: 0,
							backgroundColor: "gray",
							borderRadius: 10,
							overflow:"hidden"
						}
					}}
				>
					<div style={{ backgroundColor: "gray", width: "100%", height: "100%" }}>
						{this.handleRenderStructureModeSelectItem("bars", "Table Of Contents", "Will display the whole structure.", "toc", topLevel, dialogTheme)}
						{(topLevel === "section" || topLevel === "list") && this.handleRenderStructureModeSelectItem("list-alt", "Sections", "Display all lists and sections for overview purposes overview.", "sections", topLevel, dialogTheme)}
						{topLevel === "list" && this.handleRenderStructureModeSelectItem("list", "Lists", "Display all lists to get a higher level overview.", "lists", topLevel, dialogTheme)}
						<div style={_.assign({},dialogTheme.structureModeRow, dialogTheme.structureModeRowFunctions)}>
							<div style={dialogTheme.structureModeRowButton} onClick={this.handleHideStructureModeModal}>
								<div style={dialogTheme.structureModeRowButtonLabel}>Cancel</div>
							</div>
						</div>
					</div>
				</Modal>);
				break;
			}
			case "items": {
				const items = playerActions.getContextItems();
				if (items) {
					result = [];
					const { listIndex, sectionIndex } = this.props.selectedItem;
					items.forEach((item, idx) => {
						const title = item.navTitle ? item.navTitle : removeMd(item.label1);
						if (!item.contextSelected) {
							result.push(<div key={`list-items-${idx}`} style={styles.itemRow} onClick={() => { this.props.dispatch(playerActions.setSelectedItem, listIndex, sectionIndex, item._idx, true); }}>
								<span style={itemStyle}>{title}</span>
							</div>);
						} else {
							result.push(<div key={`list-items-${idx}`} style={styles.itemRowSelected}>
								<span style={itemStyle}>{title}</span>
							</div>);
						}
					});
				}

				break;
			}
			case "sections": {
				const sections = playerActions.getContextSections();
				if (sections) {
					result = [];
					const { listIndex } = this.props.selectedItem;
					sections.forEach((section, idx) => {
						const title = section.navTitle ? section.navTitle : getRealName(section.name);
						if (!section.contextSelected) {
							result.push(<div key={`list-items-${idx}`} style={styles.itemRow} onClick={() => { this.props.dispatch(playerActions.setSelectedItem, listIndex, section._idx, 0, true); }}>
								<span style={itemStyle}>{title}</span>
							</div>);
						} else {
							result.push(<div key={`list-items-${idx}`} style={styles.itemRowSelected}>
								<span style={itemStyle}>{title}</span>
							</div>);
						}
					});
				}
				break;
			}
			case "lists": {
				const lists = playerActions.getContextLists();
				if (lists) {
					result = [];
					// const { listIndex, sectionIndex } = this.props.selectedItem;
					lists.forEach((list, idx) => {
						const title = list.navTitle ? list.navTitle : getRealName(list.name);
						if (!list.contextSelected) {
							result.push(<div key={`list-items-${idx}`} style={styles.itemRow} onClick={() => { this.props.dispatch(playerActions.setSelectedItem, list._idx, 0, 0, true); }}>
								<span style={itemStyle}>{title}</span>
							</div>);
						} else {
							result.push(<div key={`list-items-${idx}`} style={styles.itemRowSelected}>
								<span style={itemStyle}>{title}</span>
							</div>);
						}
					});
				}
				break;
			}
			case "navStack": {
				const { navStack } = this.props;
				result = [];
				navStack.forEach((nav, i) => {
					result.push(<div style={styles.navStackRow} key={`navStack-${i}`} onClick={() => { this.props.dispatch(playerActions.goBackFromLink, false, i); }}>
						<div style={{ display: "flex", flexDirection: "row", alignItems: "center", borderBottomWidth: 1, borderBottomColor: "#888888", borderBottomStyle: "solid", paddingBottom: 5 }}>
							<span style={{ color: "white", fontSize: 12 }}>{nav.activityName}</span>
							<div style={{ width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><FontAwesomeIcon icon="caret-right" style={{ color: "#AAAAAA", fontSize: 12 }} solid /></div>
							<span style={{ color: "white", fontSize: 12 }}>{nav.listName}</span>
							<div style={{ width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><FontAwesomeIcon icon="caret-right" style={{ color: "#AAAAAA", fontSize: 12 }} solid /></div>
							<span style={{ color: "white", fontSize: 12 }}>{nav.sectionName}</span>
						</div>
						<div style={{ paddingTop: 5 }}>
							<span style={{ color: "white" }}>{nav.itemName}</span>
						</div>
					</div>);
				});
				result.push(
					<div key="navStack-Dismiss" style={styles.navStackDismissRow}>
						<div style={{ backgroundColor: "darkred", borderRadius: 5, width: 120, height: 30, display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => { this.props.dispatch(playerActions.goBackDismiss); }}>
							<span style={{ color: "white", fontWeight: "bold" }}>Clear History</span>
						</div>
					</div>
				);
				break;
			}
			default: {
				console.warn("Unknown view type", view);
			}
		}
		return result;
	}

	componentWillReceiveProps(nextProps) {

		// nav stack change
		if (nextProps.expandedView === "navStack") {
			// Hide it
			if (_.isEmpty(nextProps.navStack)) {
				this.handleHideView();
			} else {
				this.setState({
					"navStackLength": nextProps.navStack.length
				});
			}
		}

	}

	componentDidMount() {
		if (this.props.searchFocus && this.searchField && this.searchField.current && this.searchField.current.focus) {
			this.searchField.current.focus();
		}
	}
	componentDidUpdate() {
		if (this.props.searchFocus && this.searchField && this.searchField.current && this.searchField.current.focus) {
			this.searchField.current.focus();
		}
	}

	render() {

		// const { navStack, selectedItem } = this.props;
		const currentItemHierarchy = playerActions.getSelectionHierarchy();

		let breadcrumb = [];
		const { list, section, item } = currentItemHierarchy;
		if (list) {
			const needsTruncated = (!list.navTitle || _.isEmpty(list.navTitle)) && getRealName(list.name).length > 24;
			const title = list.navTitle ? list.navTitle : _.truncate(getRealName(list.name), {
				length: 24,
				omission: ""
			});
			let gradientComponent = null;
			if (needsTruncated) {
				//gradientComponent = <LinearGradient key="bc-list-gradient" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 20 }} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={['rgba(68,68,68,0)', 'rgba(68,68,68,.9)']} />
			}
			breadcrumb.push(<div style={{ position: "relative" }} key={"bc-list"}>
				<span style={{ color: "white" }}>{title}</span>
				{gradientComponent}
			</div>);
			breadcrumb.push(<div key={"bc-list-sep"} style={{ width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><FontAwesomeIcon icon="chevron-right" style={{ color: "#999999" }} /></div>);
		}
		if (section) {
			const needsTruncated = (!section.navTitle || _.isEmpty(section.navTitle)) && getRealName(section.name).length > 24;
			const title = section.navTitle ? section.navTitle : _.truncate(getRealName(section.name), {
				length: 24,
				omission: ""
			});
			let gradientComponent = null;
			if (needsTruncated) {
				//gradientComponent = <LinearGradient key="bc-section-gradient" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 20 }} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={['rgba(68,68,68,0)', 'rgba(68,68,68,.9)']} />
			}
			breadcrumb.push(<div style={{ position: "relative" }} key={"bc-section"}>
				<span style={{ color: "white" }}>{title}</span>
				{gradientComponent}
			</div>);
			breadcrumb.push(<div key={"bc-section-sep"} style={{ width: 20, height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><FontAwesomeIcon icon="chevron-right" style={{ color: "#999999" }} /></div>);
		}
		if (item) {

			const needsTruncated = (!item.navTitle || _.isEmpty(item.navTitle)) && item.label1.length > 24;
			const title = item.navTitle ? item.navTitle : _.truncate(item.label1, {
				length: 24,
				omission: ""
			});
			let gradientComponent = null;
			if (needsTruncated) {
				//gradientComponent = <LinearGradient key="bc-item-gradient" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 20 }} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={['rgba(68,68,68,0)', 'rgba(68,68,68,.9)']} />
			}

			breadcrumb.push(<div style={{ position: "relative" }} key={`bc-item-${item.guid}`}>
				<span style={{ color: "white" }}>{title}</span>
				{gradientComponent}
			</div>);
		}

		let overlayView = null;
		if (this.props.expandedView) {
			overlayView = <div key="breadcrumb-overlay" style={{ position: "absolute", top: 0, left: 0, right: 0, width: "100%", height: "100%", bottom: 0, backgroundColor: "rgba(68,68,68,.8)", display: "flex", flexDirection: "column", zIndex: 15, paddingHorizontal: 5, overflowY: "auto" }}>
				{this.handleRenderView()}
			</div>;
		}

		return (overlayView);
	}
}

const styles = {
	navStackRow: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexShrink: 0,
		borderBottomWidth: 1,
		borderBottomColor: "lightgray",
		paddingHorizontal: 5,
		paddingVertical: 5,
		paddingLeft: 15,
		cursor: "pointer",
		borderBottomStyle: "solid",
		marginLeft: 5,
		marginRight: 5,
		paddingTop: 5,
		paddingBottom: 5
	},
	navStackDismissRow: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexShrink: 0,
		paddingHorizontal: 5,
		paddingVertical: 5,
		marginTop: 10,
		paddingLeft: 15,
		cursor: "pointer",
		paddingTop: 5,
		paddingBottom: 5
	},
	itemRow: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexShrink: 0,
		borderBottomWidth: 1,
		borderBottomColor: "lightgray",
		paddingHorizontal: 5,
		paddingVertical: 5,
		paddingLeft: 15,
		cursor: "pointer",
		borderBottomStyle: "solid",
		marginLeft: 5,
		marginRight: 5,
		paddingTop: 5,
		paddingBottom: 5
	},
	itemRowSelected: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexShrink: 0,
		borderBottomWidth: 1,
		borderBottomColor: "lightgray",
		paddingHorizontal: 5,
		paddingVertical: 5,
		backgroundColor: "#888888",
		paddingLeft: 15,
		cursor: "pointer",
		borderBottomStyle: "solid",
		marginLeft: 5,
		marginRight: 5,
		paddingTop: 5,
		paddingBottom: 5
	}
};

BreadcrumbDialog.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	navStack: ["player", "navStack"],
	expandedView: ["player", "breadcrumb", "expandedView"],
	searchFocus: ["player", "breadcrumb", "searchFocus"],
	selectedItem: ["activity", "selected"]
}, BreadcrumbDialog);